type ConductricsScriptProps = {
  src?: string;
};

export function ConductricsScript({ src }: ConductricsScriptProps) {
  if (!src) return null;
  return <script src={src} data-testid="conductrics-script" type="text/javascript" defer />;
}

export default ConductricsScript;
